// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"CheckBox_checkBox__1eQlU","checkmark":"CheckBox_checkmark__1d6iO"};